import { ScrollScene } from 'scrollscene';
import { gsap } from 'gsap';

import store from 'Store';

export default function parallaxItem (element) {
    let scene;

    const elements = {
        target: element.querySelector('.js-parallax-item-target'),
        trigger: element.querySelector('.js-parallax-item-trigger'),
    };

    const baseParallaxSettings = {
        startValue: {},
        endValue: {},
        from: false,
    };

    const endValueConfig = {
        ease: 'none',
        duration: 1,
    };

    const customParallaxSettings = JSON.parse(element.dataset.parallaxSettings);

    const parallaxSettings = { ...baseParallaxSettings, ...customParallaxSettings };

    function init () {
        // element.classList.add('parallax', 'parallax-invisible');
        initScrollAnimation();
    }

    function initScrollAnimation () {
        if (scene !== undefined) return;

        const endValue = { ...parallaxSettings.endValue, ...endValueConfig };
        const myTimeline = gsap.timeline({ paused: true });

        myTimeline.fromTo(elements.target, parallaxSettings.startValue, endValue);

        const sceneOptions = {
            // breakpoints: { 0: false, 768: true },
            triggerElement: elements.trigger,
            toggle: {
                element: element,
                className: 'is-scroll-animated',
            },
            gsap: {
                timeline: myTimeline,
            },
            markers: true,
            triggerHook: element.classList.contains('js-parallax-top') ? 0 : 1,
            duration: getDuration(),
            offset: 0,
        };

        if (parallaxSettings.from) {
            const breakpointsSetting = { 0: false };
            const allBreakpoints = store.getters.getBreakpoints;
            const fromBreakpoint = allBreakpoints.filter(bp => bp.id === parallaxSettings.from)[0];
            breakpointsSetting[fromBreakpoint.width] = true;
            sceneOptions.breakpoints = breakpointsSetting;
        }

        scene = new ScrollScene(sceneOptions);

        setTimeout(() => {
            element.classList.remove('parallax--hidden');
        }, 200);
    }

    function getDuration () {
        return elements.target.offsetHeight + window.innerHeight;
    }

    init();
}
